// Carrito lateral de SRJ: reemplaza al aviso de Dawn. product-form.js lo encuentra como <srj-carrito> y le pasa la respuesta.
(function () {
  if (customElements.get('srj-carrito')) return;

  var pesos = function (centavos) { return '$U' + Math.round(centavos / 100).toLocaleString('es-UY'); };
  var esPiso = function (item) { return (item.handle || '').indexOf('piso-vinilico-spc') !== -1; };
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; };
  var conAncho = function (url, w) { if (!url) return ''; return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; };

  // Promo WPC interior (Ronald, 20/10/2026): cada 2 cajas cerradas (productos paquete "caja-wpc-interior-<color>-14-paneles",
  // se pueden combinar colores) va de regalo 1 "Kit de colocación WPC: 112 clips + adhesivo" (paquete de Shopify). Va como línea
  // aparte marcada _regalo; el descuento automático "Pack WPC: clips y adhesivo de regalo cada 2 cajas" la deja en $0.
  // Las líneas _regalo de antes (grapas y adhesivo sueltos) se sacan solas.
  var REGALO = { cada: 2, items: [{ id: 44064642007075, n: function (k) { return Math.floor(k / 2); } }] };
  var esCaja = function (it) { return (it.handle || '').indexOf('caja-wpc-interior-') === 0; };
  var esWpc = function (it) { return (it.handle || '').indexOf('wpc-wall-panel-interior') !== -1 || esCaja(it); };
  var colorWpc = function (it) { return it.handle.replace('wpc-wall-panel-interior-', '').replace(/^caja-wpc-interior-/, '').replace(/-14-paneles$/, ''); };
  var esRegalo = function (it) { return !!(it.properties && it.properties._regalo); };
  window.srjRegaloWpc = function (c) {
    var pedir = c ? Promise.resolve(c) : fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
    return pedir.then(function (c) {
      var k = c.items.filter(esCaja).reduce(function (s, it) { return s + it.quantity; }, 0);
      var kits = Math.floor(k / REGALO.cada), cambio = false, cadena = Promise.resolve();
      var ids = REGALO.items.map(function (g) { return g.id; });
      var cambiar = function (key, n) { return fetch('/cart/change.js', { method: 'POST', headers: json, body: JSON.stringify({ id: key, quantity: n }) }); };
      // regalos viejos o que no corresponden: afuera
      c.items.filter(function (it) { return esRegalo(it) && ids.indexOf(it.variant_id) === -1; }).forEach(function (it) {
        cambio = true;
        cadena = cadena.then(function () { return cambiar(it.key, 0); }).catch(function () {});
      });
      REGALO.items.forEach(function (g) {
        var quiere = g.n(k);
        var lineas = c.items.filter(function (it) { return esRegalo(it) && it.variant_id === g.id; });
        var tiene = lineas.reduce(function (s, it) { return s + it.quantity; }, 0);
        if (quiere === tiene) return;
        cambio = true;
        cadena = cadena.then(function () {
          return lineas.length
            ? cambiar(lineas[0].key, quiere)
            : fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: g.id, quantity: quiere, properties: { _regalo: 'Pack WPC' } }] }) });
        }).catch(function () {});
      });
      var nota = kits ? kits + (kits === 1 ? ' kit' : ' kits') + ' de colocación de regalo (' + (kits * 112) + ' clips + ' + kits + (kits === 1 ? ' adhesivo' : ' adhesivos') + ') por ' + k + ' cajas de WPC' : '';
      if ((c.attributes || {})['Regalo pack WPC'] !== nota && (nota || (c.attributes || {})['Regalo pack WPC'])) {
        cadena = cadena.then(function () { return fetch('/cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ attributes: { 'Regalo pack WPC': nota } }) }); });
      }
      return cadena.then(function () { return cambio; });
    }).catch(function () { return false; });
  };

  customElements.define('srj-carrito', class SrjCarrito extends HTMLElement {
    connectedCallback() {
      // vive dentro del encabezado (que es sticky y arma su propia capa): se pasa al <body> para quedar arriba de todo
      if (this.parentNode !== document.body) { document.body.appendChild(this); return; }
      if (this.listo) return;
      this.listo = true;
      var self = this;
      this.panel = this.querySelector('.srj-cl__panel');
      this.lista = this.querySelector('[data-srj-cl-lista]');
      this.addEventListener('click', function (e) {
        // placas: color de la terminación sugerida
        var col = e.target.closest('[data-srj-cl-sug-color]');
        if (col) {
          col.closest('[data-srj-cl-sug-grupo]').querySelectorAll('.srj-cl__sug-item').forEach(function (it) { it.hidden = it.getAttribute('data-color') !== col.getAttribute('data-srj-cl-sug-color'); });
          return;
        }
        var paso = e.target.closest('[data-srj-cl-sug-paso]');
        if (paso) {
          var ni = paso.parentNode.querySelector('[data-srj-cl-sug-n]');
          ni.value = Math.max(0, (parseInt(ni.value, 10) || 0) + parseInt(paso.getAttribute('data-srj-cl-sug-paso'), 10));
          ni.closest('.srj-cl__sug-accion').querySelector('[data-srj-cl-sug-agregar]').disabled = !(+ni.value >= 1);
          return;
        }
        var b = e.target.closest('[data-srj-cl-sug-agregar]');
        if (!b || b.disabled) return;
        b.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: +b.getAttribute('data-srj-cl-sug-agregar'), quantity: parseInt(b.parentNode.querySelector('[data-srj-cl-sug-n]').value, 10) || 0 }) })
          .then(function (r) { return r.json(); })
          .then(function (item) { self.agregado = item && item.key ? item : null; self.cargar(); })
          .catch(function () { b.disabled = false; });
      });
      var zs = this.querySelector('[data-srj-cl-zona]');
      if (zs) zs.addEventListener('change', function () { self.zona(zs.value); });
      this.addEventListener('input', function (e) {
        if (!e.target.hasAttribute('data-srj-cl-sug-n')) return;
        e.target.closest('.srj-cl__sug-accion').querySelector('[data-srj-cl-sug-agregar]').disabled = !((parseInt(e.target.value, 10) || 0) >= 1);
      });
      this.querySelectorAll('[data-srj-cl-cerrar]').forEach(function (b) { b.addEventListener('click', function () { self.cerrar(); }); });
      this.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.cerrar(); });
      // el ícono del carrito del encabezado abre el carrito lateral en vez de ir a /cart
      document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('#cart-icon-bubble');
        if (!a || e.metaKey || e.ctrlKey) return;
        e.preventDefault();
        self.activo = a;
        self.abrir();
      });
      // cambios de cantidad y quitar
      this.lista.addEventListener('click', function (e) {
        var b = e.target.closest('[data-srj-cl-cambio]');
        if (!b) return;
        var fila = b.closest('[data-key]');
        var actual = parseInt(fila.dataset.cantidad, 10);
        var nueva = b.dataset.srjClCambio === 'quitar' ? 0 : Math.max(0, actual + parseInt(b.dataset.srjClCambio, 10));
        self.cambiar(fila.dataset.key, nueva);
      });
      this.lista.addEventListener('change', function (e) {
        var i = e.target.closest('[data-srj-cl-cantidad]');
        if (!i) return;
        var n = parseInt(i.value, 10);
        self.cambiar(i.closest('[data-key]').dataset.key, isNaN(n) || n < 0 ? 0 : n);
      });
    }

    // lo que pide product-form.js de Dawn
    getSectionsToRender() { return [{ id: 'cart-icon-bubble' }]; }
    setActiveElement(el) { this.activo = el; }
    renderContents(respuesta) {
      this.agregado = respuesta && respuesta.key ? respuesta : null;
      this.abrir();
    }

    abrir() {
      var self = this;
      this.hidden = false;
      document.body.classList.add('overflow-hidden', 'srj-cl-abierto');
      requestAnimationFrame(function () { self.classList.add('is-abierto'); self.panel.focus(); });
      this.entrega();
      if (!this.reloj) this.reloj = setInterval(function () { self.entrega(); }, 1000);
      this.cargar();
    }
    cerrar() {
      var self = this;
      this.classList.remove('is-abierto');
      clearInterval(this.reloj); this.reloj = null;
      document.body.classList.remove('overflow-hidden', 'srj-cl-abierto');
      setTimeout(function () { if (!self.classList.contains('is-abierto')) self.hidden = true; }, 300);
      if (this.activo && this.activo.focus) this.activo.focus();
    }

    cargar() {
      var self = this;
      this.classList.add('is-cargando');
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          // el regalo del pack WPC se ajusta solo; si cambió, se vuelve a pedir el carrito
          return window.srjRegaloWpc(c).then(function (cambio) { return cambio ? fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }) : c; });
        })
        .then(function (c) { return self.conListas(c); })
        .then(function (c) { self.pintar(c); })
        .finally(function () { self.classList.remove('is-cargando'); });
    }
    // cart.js no trae el precio de lista: se busca en /products/<handle>.js (una vez por producto)
    conListas(c) {
      var cache = this.listas || (this.listas = {});
      var faltan = c.items.filter(function (it) { return !(it.handle in cache); }).map(function (it) { return it.handle; });
      faltan = faltan.filter(function (h, i) { return faltan.indexOf(h) === i; });
      return Promise.all(faltan.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          cache[h] = {};
          if (p && p.variants) p.variants.forEach(function (v) { cache[h][v.id] = v.compare_at_price || 0; });
        }).catch(function () { cache[h] = {}; });
      })).then(function () {
        c.items.forEach(function (it) { it.compare_at_price = (cache[it.handle] || {})[it.variant_id] || 0; });
        return c;
      });
    }
    cambiar(key, cantidad) {
      var self = this;
      this.classList.add('is-cargando');
      this.agregado = null;
      // un mismo producto puede venir partido en varias líneas (el descuento del pack las separa): se deja todo en la primera
      var keys = String(key).split(',');
      if (keys.length > 1) {
        var paso = function (i) {
          if (i >= keys.length) return Promise.resolve();
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: keys[i], quantity: i ? 0 : cantidad }) }).then(function () { return paso(i + 1); });
        };
        return paso(0).then(function () { return self.cargar(); }).finally(function () { self.classList.remove('is-cargando'); });
      }
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: cantidad })
      })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (c && c.items) return self.conListas(c).then(function (cc) { self.pintar(cc); }); return self.cargar(); })
        .finally(function () { self.classList.remove('is-cargando'); });
    }

    // cuenta regresiva de entrega (assets/srj-entrega.js); corre solo con el carrito abierto
    entrega() {
      if (!window.srjEntrega) return;
      var e = window.srjEntrega();
      this.querySelector('[data-srj-cl-entrega-texto]').textContent = e.texto;
      this.querySelector('[data-srj-cl-entrega-avance]').style.width = e.avance + '%';
    }

    pintar(c) {
      var self = this;
      var q = function (s) { return self.querySelector(s); };
      // contador del encabezado
      document.querySelectorAll('.srj-carrito__contador span[aria-hidden]').forEach(function (s) { s.textContent = c.item_count; });
      q('[data-srj-cl-cuenta]').textContent = c.item_count ? '(' + c.items.length + ')' : '';

      var vacio = !c.items.length;
      q('[data-srj-cl-vacio]').hidden = !vacio;
      q('[data-srj-cl-pie]').hidden = vacio;
      this.lista.hidden = vacio;

      // sin aviso de "Agregaste…": lo recién agregado se marca con el borde verde de la foto (pedido de Ronald, 19/10/2026)

      var ahorro = 0;
      // mismas variantes partidas en varias líneas (por el descuento del pack) se muestran juntas
      var juntas = [];
      c.items.forEach(function (it) {
        var j = !esRegalo(it) && juntas.filter(function (x) { return !esRegalo(x) && x.variant_id === it.variant_id; })[0];
        if (j) { j.quantity += it.quantity; j.final_line_price += it.final_line_price; j.key += ',' + it.key; }
        else juntas.push(Object.assign({}, it));
      });
      this.lista.innerHTML = juntas.map(function (it) {
        var piso = esPiso(it);
        if (esRegalo(it)) {
          return '<div class="srj-cl__item srj-cl__item--regalo" data-key="' + esc(it.key) + '">' +
            '<span class="srj-cl__foto"><img src="' + esc(conAncho(it.image, 160)) + '" width="56" height="56" alt="" loading="lazy"></span>' +
            '<div class="srj-cl__datos"><span class="srj-cl__regalo-tag">Regalo por llevar 2 cajas</span>' +
            '<span class="srj-cl__nombre">' + it.quantity + ' × ' + esc(it.product_title) + '</span></div>' +
            '<strong class="srj-cl__precio srj-cl__gratis-si">Gratis</strong></div>';
        }
        var lista = (it.compare_at_price || 0) > it.price ? it.compare_at_price : 0;
        if (lista) ahorro += (lista - it.price) * it.quantity;
        var variante = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="srj-cl__variante">' + esc(it.variant_title) + '</span>' : '';
        var unidad = piso ? pesos(it.price) + ' el m²' : pesos(it.price) + ' c/u';
        var nuevo = self.agregado && it.key.split(',').indexOf(self.agregado.key) >= 0 ? ' is-nuevo' : '';
        return '<div class="srj-cl__item' + nuevo + '" data-key="' + esc(it.key) + '" data-cantidad="' + it.quantity + '">' +
          '<a class="srj-cl__foto" href="' + esc(it.url) + '"><img src="' + esc(conAncho(it.image, 160)) + '" width="80" height="80" alt="" loading="lazy"></a>' +
          '<div class="srj-cl__datos">' +
            '<a class="srj-cl__nombre" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variante +
            '<span class="srj-cl__unidad">' + unidad + (lista ? ' <s>' + pesos(lista) + '</s>' : '') + '</span>' +
            '<div class="srj-cl__fila">' +
              '<div class="srj-cl__cantidad">' +
                '<button type="button" data-srj-cl-cambio="-1" aria-label="Menos">−</button>' +
                '<input type="number" min="0" inputmode="numeric" value="' + it.quantity + '" data-srj-cl-cantidad aria-label="Cantidad' + (piso ? ' en m²' : '') + '">' +
                '<button type="button" data-srj-cl-cambio="1" aria-label="Más">+</button>' +
              '</div>' + (piso ? '<span class="srj-cl__m2">m²</span>' : '') +
              '<strong class="srj-cl__precio">' + pesos(it.final_line_price) + '</strong>' +
            '</div>' +
            '<button type="button" class="srj-cl__quitar" data-srj-cl-cambio="quitar">Quitar</button>' +
          '</div>' +
        '</div>';
      }).join('');

      q('[data-srj-cl-total]').textContent = pesos(c.total_price);
      q('[data-srj-cl-cuota]').textContent = pesos(c.total_price / 12);
      var ah = q('[data-srj-cl-ahorro]');
      ah.hidden = !ahorro;
      if (ahorro) q('[data-srj-cl-ahorro-n]').textContent = pesos(ahorro);

      this.carrito = c;
      var zs = q('[data-srj-cl-zona]');
      // la zona que eligió el cliente en esta página manda: una recarga lenta puede traer todavía la zona vieja guardada en Shopify
      // (le pasó a Ronald 26/10: elegía retiro y volvía a Montevideo con el envío sumado)
      var guardada = this.zonaElegida || (c.attributes || {})['Zona de envío'] || '';
      if (zs && guardada && zs.value !== guardada) zs.value = guardada;
      q('[data-srj-cl-zona-fila]').hidden = vacio;
      this.pintarGratis();
      this.sugerir(c);
      document.dispatchEvent(new CustomEvent('srj:carrito', { detail: c }));
      // aviso del pack WPC: con un número impar de cajas, falta 1 para el (siguiente) regalo
      var k = c.items.filter(esCaja).reduce(function (s, it) { return s + it.quantity; }, 0), pk = q('[data-srj-cl-pack]');
      if (pk) {
        pk.hidden = k % 2 === 0;
        if (!pk.hidden) pk.innerHTML = 'Sumá <b>1 caja más</b> de WPC (de cualquier color) y te regalamos <b>los clips y el adhesivo</b>.';
      }
    }

    // Accesorios del piso SPC del mismo color (mismo orden que la ficha; zócalo blanco último), los que no estén ya en el carrito; sin stock se ven apagados.
    // Placas símil mármol (23/10/2026): las 4 terminaciones con botones de color (blanco/negro/plateado; arranca en negro si la
    // placa es oscura) y el adhesivo. Cada sugerencia es un grupo de productos alternativos (uno por color).
    sugerir(c) {
      var self = this, caja = this.querySelector('[data-srj-cl-sug]');
      if (!caja) return;
      var piso = c.items.filter(esPiso)[0];
      var pared = c.items.filter(function (it) { return /wpc-wall-panel-interior|caja-wpc-interior-|placa-pvc-simil-marmol/.test(it.handle || ''); })[0];
      var wpc = c.items.filter(esWpc)[0];
      if (!piso && !pared) { caja.hidden = true; return; }
      var grupos, placa = !piso && !wpc, colorInicial = 'blanco';
      if (piso) {
        var color = piso.handle.replace('piso-vinilico-spc-', '');
        grupos = ['zocalo-spc-', 'perfil-t-spc-', 'reductor-spc-', 'remate-de-borde-spc-'].map(function (h) { return h + color; }).concat('zocalo-blanco-eps', 'adhesivo-de-montaje-clavo-liquido');
      } else if (wpc) {
        var cw = colorWpc(wpc);
        grupos = ['iniciar-', 'finalizar-', 'angulo-'].map(function (h) { return 'perfil-wpc-interior-' + h + cw; }).concat('grapa-montaje-panel-wpc-interior', 'adhesivo-de-montaje-clavo-liquido');
      } else {
        if (/-negro-|grafito-oro|gris-oro/.test(pared.handle)) colorInicial = 'negro';
        grupos = ['perfil-union', 'esquinero-interno', 'esquinero-externo', 'perfil-j'].map(function (t) {
          return ['blanco', 'negro', 'plateado'].map(function (k) { return t + '-' + k + '-placa-simil-marmol'; });
        }).concat('adhesivo-de-montaje-clavo-liquido');
      }
      grupos = grupos.map(function (g) { return [].concat(g); });
      caja.querySelector('.srj-cl__sug-titulo').textContent = piso ? 'Completá tu piso' : 'Completá tu pared';
      var enCarrito = c.items.map(function (it) { return it.handle; });
      // con el kit de regalo (clips + adhesivo) en el carrito no se ofrecen grapas ni adhesivo sueltos
      if (c.items.some(function (it) { return esRegalo(it) && it.variant_id === REGALO.items[0].id; })) enCarrito = enCarrito.concat('grapa-montaje-panel-wpc-interior', 'adhesivo-de-montaje-clavo-liquido');
      // si ya hay una terminación de ese tipo en el carrito (de cualquier color), no se vuelve a ofrecer
      grupos = grupos.filter(function (g) { return !g.some(function (h) { return enCarrito.indexOf(h) !== -1; }); });
      this.prods = this.prods || {};
      var traer = function (h) {
        if (h in self.prods) return self.prods[h];
        return (self.prods[h] = fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }));
      };
      var colorDe = function (p) { return (p.handle.match(/-(blanco|negro|plateado)-placa-simil-marmol$/) || [])[1] || ''; };
      Promise.all(grupos.map(function (g) { return Promise.all(g.map(traer)); })).then(function (pss) {
        // se muestran todos; los que no tienen stock dicen "Sin stock" y se habilitan solos cuando se carga stock en Shopify
        var item = function (p, chips, oculto) {
          var v = p.variants[0];
          // medidas de Ronald: tira de 2,4 m (a tono) y 2,90 m (zócalo blanco, perfiles WPC y terminaciones de placa). La cantidad la elige el cliente: arranca en 0, sin sugerencias.
          var tira = p.handle === 'zocalo-blanco-eps' ? '2,9' : p.handle.indexOf('perfil-wpc') === 0 || colorDe(p) ? '2,90' : '2,4';
          var nota = p.handle.indexOf('adhesivo') === 0 ? (placa ? 'pomo de 360 g · 1 por placa' : 'pomo de 360 g') : p.handle.indexOf('grapa') === 0 ? '4 por panel' : 'tira de ' + tira + ' m';
          return '<div class="srj-cl__sug-item"' + (oculto ? ' hidden' : '') + ' data-color="' + colorDe(p) + '">' +
            '<a class="srj-cl__sug-foto" href="/products/' + esc(p.handle) + '"><img src="' + esc(conAncho(p.featured_image, 120)) + '" width="48" height="48" alt="" loading="lazy"></a>' +
            '<div class="srj-cl__sug-datos"><a href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a><span>' + pesos(v.price) + ' c/u · ' + nota + '</span>' + chips +
              (!v.available ? '<div class="srj-cl__sug-accion"><button type="button" class="srj-cl__sug-agregar" disabled>Sin stock</button></div>' :
              '<div class="srj-cl__sug-accion">' +
                '<div class="srj-cl__cantidad srj-cl__sug-cant"><button type="button" data-srj-cl-sug-paso="-1" aria-label="Menos">−</button>' +
                '<input type="number" min="0" inputmode="numeric" value="0" data-srj-cl-sug-n aria-label="Cantidad">' +
                '<button type="button" data-srj-cl-sug-paso="1" aria-label="Más">+</button></div>' +
                '<button type="button" class="srj-cl__sug-agregar" data-srj-cl-sug-agregar="' + v.id + '" disabled>Agregar</button>' +
              '</div>') +
            '</div>' +
          '</div>';
        };
        var html = pss.map(function (ps) {
          var ok = ps.filter(function (p) { return p && p.variants && p.variants[0]; });
          if (!ok.length) return '';
          if (ok.length === 1) return item(ok[0], '', false);
          var activo = ok.some(function (p) { return colorDe(p) === colorInicial; }) ? colorInicial : colorDe(ok[0]);
          return '<div class="srj-cl__sug-grupo" data-srj-cl-sug-grupo>' + ok.map(function (p) {
            var chips = '<div class="srj-cl__sug-colores" role="radiogroup" aria-label="Color">' + ok.map(function (q) {
              var k = colorDe(q);
              return '<button type="button" role="radio" class="srj-cl__sug-color srj-cl__sug-color--' + k + '" data-srj-cl-sug-color="' + k + '" aria-checked="' + (k === colorDe(p)) + '">' + k.charAt(0).toUpperCase() + k.slice(1) + '</button>';
            }).join('') + '</div>';
            return item(p, chips, colorDe(p) !== activo);
          }).join('') + '</div>';
        }).join('');
        caja.hidden = !html;
        caja.querySelector('[data-srj-cl-sug-lista]').innerHTML = html;
      });
    }

    // Envío gratis y zona: Montevideo y alrededores tienen la barra; otro lugar, "lo coordinamos por WhatsApp"; retiro, dirección y horario.
    pintarGratis() {
      var self = this, c = this.carrito;
      var q = function (s) { return self.querySelector(s); };
      var gr = q('[data-srj-cl-gratis]'), co = q('[data-srj-cl-coordinar]'), zs = q('[data-srj-cl-zona]');
      if (!gr || !c) return;
      this.pintarEnvio();
      var vacio = !c.items.length;
      var op = zs && zs.selectedOptions[0], tipo = op && op.getAttribute('data-tipo') || '';
      var meta = parseFloat(gr.getAttribute('data-srj-cl-gratis')) * 100;
      co.hidden = vacio || tipo !== 'lejos';
      q('[data-srj-cl-retiro]').hidden = vacio || tipo !== 'retiro';
      if (tipo === 'lejos') q('[data-srj-cl-coordinar-texto]').textContent = op.value === 'Otro lugar de Canelones'
        ? 'Antes de comprar, consultanos por WhatsApp si llegamos a tu zona.'
        : 'Al interior enviamos por agencia. Terminás la compra acá y después te escribimos por WhatsApp para coordinar el envío.';
      if (tipo === 'lejos') q('[data-srj-cl-coordinar-link]').hidden = op.value !== 'Otro lugar de Canelones';
      // con retiro no corre la cuenta regresiva de entrega
      var ent = q('[data-srj-cl-entrega]');
      if (ent) ent.hidden = tipo === 'retiro';
      gr.hidden = vacio || !meta || tipo === 'lejos' || tipo === 'retiro';
      if (gr.hidden) return;
      var donde = tipo === 'cerca' ? (op.value === 'Montevideo' ? 'en Montevideo' : 'a ' + op.value) : 'en Montevideo y alrededores';
      var falta = meta - c.total_price;
      gr.classList.toggle('is-lograda', falta <= 0);
      q('[data-srj-cl-gratis-texto]').innerHTML = falta > 0
        ? 'Te faltan <strong>' + pesos(falta) + '</strong> para tener <strong>envío gratis</strong> ' + esc(donde)
        : '<strong>¡Tenés envío gratis!</strong> ' + esc(donde);
      q('[data-srj-cl-gratis-relleno]').style.width = Math.min(100, c.total_price / meta * 100) + '%';
      // Canelones cercano: se paga en la web igual que Montevideo ($650 en la tienda), gratis desde el mismo monto
      var nota = q('[data-srj-cl-gratis-nota]'), canel = op && op.hasAttribute('data-canelones');
      var flete = parseFloat(gr.getAttribute('data-srj-cl-flete-cerca'));
      nota.hidden = !canel || falta <= 0;
      if (canel && falta > 0) nota.textContent = 'Si no, el envío a ' + op.value + ' es ' + pesos(flete * 100) + '.';
    }

    // Fila de envío del pie y total: Montevideo y Canelones cercano suman el envío (se cobra en la web); el resto no cambia el total.
    pintarEnvio() {
      var self = this, c = this.carrito;
      var q = function (s) { return self.querySelector(s); };
      var fila = q('[data-srj-cl-envio-fila]'), zs = q('[data-srj-cl-zona]'), gr = q('[data-srj-cl-gratis]');
      if (!fila || !c) return;
      var op = zs && zs.selectedOptions[0], tipo = op && op.getAttribute('data-tipo') || '';
      var meta = parseFloat(gr.getAttribute('data-srj-cl-gratis')) * 100;
      var gratis = c.total_price >= meta;
      var et, monto, suma = 0;
      if (tipo === 'retiro') { et = 'Retiro en el local'; monto = '<strong class="srj-cl__gratis-si">Gratis</strong>'; }
      else if (tipo === 'lejos') { et = 'Envío'; monto = 'Lo coordinamos por WhatsApp'; }
      else if (tipo === 'cerca' && op.value === 'Montevideo') {
        var mvd = parseFloat(fila.getAttribute('data-srj-cl-envio-mvd')) * 100;
        et = 'Envío a Montevideo';
        if (gratis) monto = '<strong class="srj-cl__gratis-si">Gratis</strong>'; else { monto = pesos(mvd); suma = mvd; }
      } else if (tipo === 'cerca') {
        var can = parseFloat(gr.getAttribute('data-srj-cl-flete-cerca')) * 100;
        et = 'Envío a ' + esc(op.value);
        if (gratis) monto = '<strong class="srj-cl__gratis-si">Gratis</strong>'; else { monto = pesos(can); suma = can; }
      } else { et = 'Envío'; monto = 'Elegí tu zona arriba'; }
      q('[data-srj-cl-envio-et]').innerHTML = et;
      q('[data-srj-cl-envio-monto]').innerHTML = monto;
      q('[data-srj-cl-total]').textContent = pesos(c.total_price + suma);
      q('[data-srj-cl-cuota]').textContent = pesos((c.total_price + suma) / 12);
    }

    zona(valor) {
      var self = this;
      this.zonaElegida = valor;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { 'Zona de envío': valor } }) })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (self.carrito && c && c.attributes) self.carrito.attributes = c.attributes; })
        .catch(function () {});
      this.pintarGratis();
    }
  });
})();
